// Port of api/fuel/app/classes/filter/package/games/rating/prepare/rating.php
export default {
	run: function(local, global) {
		var revisions = (global.revisions && global.revisions[local.game_id]) ? global.revisions[local.game_id] : []
		local.rating = revisions.length ? revisions[revisions.length - 1] : false
		return local
	}
}
